export default "__VITE_ASSET__DkVZvGmY__"